import { TyreAxles, TyreSpecification } from "../data/models"

export function findAxleSpecification(selectedSpecification: TyreSpecification, size: string) {
    const axleSpecification: TyreAxles | undefined = selectedSpecification.specifications?.find(
        (specification) => size === `${specification.frontAxle?.size} ${specification.frontAxle?.wheelSize}`
    )

    return axleSpecification
}
